import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CalendarSurfaceDefaultComponent, combineHandlers } from 'owa-calendar-surface-core';
import {
    CalendarSurfaceStore,
    CalendarSurfaceTransformProps,
    useColumnSelectionHooks,
    WorkingHoursContent,
} from 'owa-calendar-surface-dategrid';
import { OwaDate } from 'owa-datetime';

export interface DayGridColumnAdditionalPropsType {
    store: CalendarSurfaceStore;
    config: CalendarSurfaceTransformProps;
    index: number;
    date: OwaDate;
}

export default observer(function DayGridColumnComponent({
    className,
    style,
    children,
    handlers,
    additionalProps,
}: {
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
    handlers?: React.DOMAttributes<HTMLElement>;
    additionalProps: DayGridColumnAdditionalPropsType;
}) {
    const { config, store, index, date } = additionalProps;

    const finalChildren = [<React.Fragment key="originalChildren">{children}</React.Fragment>];

    if (!config.disableWorkingHours) {
        finalChildren.push(
            <WorkingHoursContent
                key={'workingHoursContent'}
                surfaceStore={store}
                modelDate={date}
            />
        );
    }

    const columnSelectionHooks = useColumnSelectionHooks({
        surfaceStore: store,
        config: config,
        columnIndex: index,
    });

    finalChildren.push(
        <React.Fragment key="columnSelectionContent">
            {columnSelectionHooks.children}
        </React.Fragment>
    );
    const handlersToAttach = combineHandlers(columnSelectionHooks.handlers, handlers);

    return (
        <CalendarSurfaceDefaultComponent
            className={className}
            style={style}
            handlers={handlersToAttach}>
            {finalChildren}
        </CalendarSurfaceDefaultComponent>
    );
});
